var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page__home"},[_c('page-header',{attrs:{"id":"a"}}),_c('tab-bar'),_c('router-view'),_c('page-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }